/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useLayout } from "@layout/app/LayoutContext";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PageSEO } from "@/shared/seo";
import { SideMenuLink } from "@layout/app/side-menu/SideMenuLink";
import {
  CrudProvider,
} from "@features/property-management/context/PropertyManagementContext";
import { useAgency } from "../AgenciesContext";
import ManageVisitsPage from "@/features/visits/pages/ManageVisitsPage";

/**
 * Agency-scoped visits page: registers the visits side-menu link for the active
 * agency and renders the visits management screen inside the CRUD provider.
 *
 * @returns The visits management page wrapped in its CRUD context and SEO title.
 */
const AgencyVisits = () => {
  const { updateNavigationBar } = useLayout((state) => state);
  const { agency } = useAgency((state) => state);
  const { t } = useTranslation('@pages/agencies');

  useEffect(() => {
    const visitsPath = `/app/agencies/${agency.id}/visits`;
    const visits_navigate = (
      <SideMenuLink label={t('visits.title')} linkTo={visitsPath} />
    );
    updateNavigationBar(visits_navigate, 1);
  }, [agency.id]);

  return (
    <CrudProvider initialState={{ fetchSettings: { pageSize: 10, page: 1 } }}>
      <PageSEO title={t("pageTitle")} />
      <ManageVisitsPage />
    </CrudProvider>
  );
};

export default AgencyVisits;
